import './App.css';
import React, { useEffect, useRef } from 'react';
import { Routes, Route, Navigate, Outlet, useNavigate } from "react-router-dom";

import LoginPage from './Views/Login/LoginPage';
import SignUpPage from './Views/Login/SignUpPage';
import SendMail from './Views/PasswordReset/SendMail';
import ResetWithToken from './Views/PasswordReset/ResetWithToken';
import LoginLayout from './Views/Layout/LoginLayout';
import MainPage from './Views/Welcome/MainPage';
import DSE from './Components/DSE';
import { SearchPage } from './Views/Main/SearchPage';

function App() {

  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  if (token) {
    if (
      window.location.pathname === "/login" ||
      window.location.pathname === "/register"
    ) {
      navigate("/");
    }
  }

  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<MainPage />} />
        <Route path="/search" element={<SearchPage/>}/>
        <Route path="/datenschutz" element={<DSE />} />
        <Route element={<LoginLayout />}>
            <Route path="login" element={<LoginPage />} />
            <Route path="register" element={<SignUpPage />} />
            <Route path="send_reset" element={<SendMail />} />
            <Route path="reset_password/:token" element={<ResetWithToken />} />
          </Route>
        <Route path="*" element={<Navigate to={"/"} />} />
      </Route>
    </Routes>
  );
}

/* Main Layout */
function Layout() {
  return (
    <div className="flex bg-[#D9D9D9] overflow-hidden h-full w-full" >
      <Outlet />
    </div>
  )
}

export default App;
